import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type Props = {
  offsetSeconds?: number
  cascadeSeconds?: number
}

const signedSeconds = (value: number) => `${value > 0 ? '+' : ''}${value}`

const AssignmentReminderTimeBadge = ({
  offsetSeconds = 0,
  cascadeSeconds = 0,
}: Props) => {
  const { t } = useTranslation()
  const total = offsetSeconds + cascadeSeconds
  if (total === 0) return null

  const hasOffset = offsetSeconds !== 0
  const hasCascade = cascadeSeconds !== 0
  const tooltip =
    hasOffset && hasCascade
      ? t(
          'dashboard.team.plans.assignments.reminder-time-badge-offset-and-cascade',
          {
            offset: signedSeconds(offsetSeconds),
            cascade: signedSeconds(cascadeSeconds),
          },
        )
      : hasOffset
      ? t('dashboard.team.plans.assignments.reminder-time-badge-offset', {
          offset: signedSeconds(offsetSeconds),
        })
      : t('dashboard.team.plans.assignments.reminder-time-badge-cascade', {
          cascade: signedSeconds(cascadeSeconds),
        })

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className='inline-flex shrink-0'>
          <Badge
            variant='info'
            className='px-1.5 py-0 text-[10px] font-medium leading-4'
          >
            {signedSeconds(total)}s
          </Badge>
        </span>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  )
}

export default AssignmentReminderTimeBadge
